import type { CustomerAnalyticsMoodysReportDto, LocalDate } from '@zg-rentals/ts-customer-analytics-client';
import { Text, View } from '@react-pdf/renderer';
import { styles } from './pdfStyles';
import { MarketTrendsColumn, MarketTrendsPageWrapper, MarketTrendsTextHeader } from './MarketTrendsComponents';
import { getRowStyle } from './pdfImageUtils';
import React from 'react';

const smallColumnWidth = 6;
const mediumColumnWidth = 10;
const largeColumnWidth = 14.8;

const getStringFromLocalDate = (date: LocalDate) => {
  if (!date) {
    return '-';
  }
  return `${date.month.toString().padStart(2, '0')}/${date.day.toString().padStart(2, '0')}/${date.year}`;
};

export const TopNewConstructionPage = ({ report }: { report: CustomerAnalyticsMoodysReportDto }) => {
  return (
    <MarketTrendsPageWrapper quarter={report.dataAsOfQuarter} year={report.dataAsOfYear}>
      <View style={styles.containerBase}>
        <MarketTrendsTextHeader headerText="Top Multifamily New Construction Projects By Size" paddingBottom={20} />
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <MarketTrendsColumn width={largeColumnWidth} textAlign="left">
              <Text>Property Name</Text>
            </MarketTrendsColumn>
            <MarketTrendsColumn width={mediumColumnWidth} textAlign="left">
              <Text>Property Type</Text>
            </MarketTrendsColumn>
            <MarketTrendsColumn width={smallColumnWidth}>
              <Text>Size</Text>
              <Text style={styles.tableSubHeading}>units</Text>
            </MarketTrendsColumn>
            <MarketTrendsColumn width={largeColumnWidth} textAlign="left">
              <Text>Construction</Text>
              <Text>Status</Text>
            </MarketTrendsColumn>
            <MarketTrendsColumn width={mediumColumnWidth} textAlign="left">
              <Text>Expected Completion</Text>
            </MarketTrendsColumn>
            <MarketTrendsColumn width={largeColumnWidth} textAlign="left">
              <Text>Expected</Text>
              <Text>Groundbreak</Text>
            </MarketTrendsColumn>
            <MarketTrendsColumn width={largeColumnWidth} textAlign="left">
              <Text>Developer</Text>
            </MarketTrendsColumn>
            <MarketTrendsColumn width={largeColumnWidth} textAlign="left">
              <Text>Developer Phone</Text>
            </MarketTrendsColumn>
          </View>
          {report.topNewConstructionReport.map((data) => (
            <React.Fragment key={data.propertyName}>
              <View style={styles.rowTextHighlight}>
                <MarketTrendsColumn width={100} textAlign="left">
                  <Text> {data.address}</Text>
                </MarketTrendsColumn>
              </View>
              <View style={getRowStyle(1)}>
                <MarketTrendsColumn width={largeColumnWidth} textAlign="left">
                  <Text>{data.propertyName}</Text>
                </MarketTrendsColumn>
                <MarketTrendsColumn width={mediumColumnWidth} textAlign="left">
                  <Text>{data.propertyType}</Text>
                </MarketTrendsColumn>
                <MarketTrendsColumn width={smallColumnWidth}>
                  <Text>{data.size.toLocaleString()}</Text>
                </MarketTrendsColumn>
                <MarketTrendsColumn width={largeColumnWidth} textAlign="left">
                  <Text>{data.constructionStatus}</Text>
                </MarketTrendsColumn>
                <MarketTrendsColumn width={mediumColumnWidth} textAlign="left">
                  <Text>{getStringFromLocalDate(data.expectedCompletionDate)}</Text>
                </MarketTrendsColumn>
                <MarketTrendsColumn width={largeColumnWidth} textAlign="left">
                  <Text>{data.expectedGroundbreak || '-'}</Text>
                </MarketTrendsColumn>
                <MarketTrendsColumn width={largeColumnWidth} textAlign="left">
                  <Text>{data.developer || '-'}</Text>
                </MarketTrendsColumn>
                <MarketTrendsColumn width={largeColumnWidth} textAlign="left">
                  <Text>{data.developerPhone || '-'}</Text>
                </MarketTrendsColumn>
              </View>
            </React.Fragment>
          ))}
        </View>
      </View>
    </MarketTrendsPageWrapper>
  );
};
